<ng-container *ngIf="licenseValidity && !hideLicenseValidity">
  <transloco
    *ngIf="licenseValidity.asOfNow && licenseValidity.granularity === 'DATE_TIME'"
    [key]="
      isLimitedTermDuration(licenseValidity.duration)
        ? 'marketplace.product.licenseValidity.asOfNowFor'
        : licenseValidity.duration === 'UNLIMITED'
        ? 'marketplace.product.licenseValidity.asOfNow'
        : 'marketplace.product.licenseValidity.asOfNowUntilDateTime'
    "
    [params]="{
      date: licenseValidity.date | licenseValidityDate: licenseValidity.granularity | async,
      endDate: licenseValidity.date | licenseValidityEndDate: licenseValidity.duration | licenseValidityDate: licenseValidity.granularity | async,
      duration: (isLimitedTermDuration(licenseValidity.duration) ? licenseValidity.duration : null) | licenseValidityDuration | async,
      id: '69dbbc67-1bbf-4a70-a8c1-252768b9d457'
    }">
  </transloco>

  <transloco
    *ngIf="licenseValidity.duration && !(licenseValidity.asOfNow && licenseValidity.granularity === 'DATE_TIME')"
    [key]="isEndDate(licenseValidity.duration) ? 'marketplace.product.licenseValidity.validFromUntil' : 'marketplace.product.licenseValidity.validFrom'"
    [params]="{
      date: licenseValidity.date | licenseValidityDate: licenseValidity.granularity | async,
      endDate: licenseValidity.date | licenseValidityEndDate: licenseValidity.duration | licenseValidityDate: licenseValidity.granularity | async,
      id: '559b47a9-7fda-4a18-bc04-49029b4276bd'
    }">
  </transloco>

  <transloco
    *ngIf="licenseValidity.duration === null"
    [key]="licenseValidity.granularity === 'MONTH' ? 'marketplace.product.licenseValidity.validInMonth' : 'marketplace.product.licenseValidity.validOnDate'"
    [params]="{
      date: licenseValidity.date | licenseValidityDate: licenseValidity.granularity | async,
      id: '5fd84e71-c87d-432e-82fa-fd9819d49956'
    }">
  </transloco>
</ng-container>
